module.exports = __webpack_public_path__ + "img/03223cc.jpg";